import axios from 'axios';

const BASE = '/api/v1/manual-collections';

export interface ManualCollection {
  id: string;
  riderPublicId: string;
  clientRiderId?: string;
  riderName?: string;
  riderMobile?: string;
  city?: string;
  clientName?: string;
  vehicleNumber?: string;
  purpose?: string;
  paymentMode?: string;
  amountPaid?: number;
  utrNumber?: string;
  collectedBy?: string;
  collectedDate?: string | null;
  remarks?: string;
  createdAt?: string;
  updatedAt?: string;
}

const authHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const list = async (params: any) => {
  const res = await axios.get(BASE, { params, headers: authHeaders() });
  return res.data;
};

const exportAll = async (params?: { city?: string; fromDate?: string; toDate?: string }) => {
  const res = await axios.get(`${BASE}/export`, {
    params,
    headers: authHeaders(),
    responseType: 'arraybuffer',
  });
  return res;
};

const listByCity = async (city: string, params?: any) => {
  const res = await axios.get(`${BASE}/city/${encodeURIComponent(city)}`, { params, headers: authHeaders() });
  return res.data;
};

const create = async (payload: any) => {
  const res = await axios.post(BASE, payload, { headers: authHeaders() });
  return res.data;
};

export interface BulkManualCollectionResponse {
  success: boolean;
  message: string;
  summary: {
    totalRows: number;
    successCount: number;
    failureCount: number;
  };
  successes: Array<{ rowNumber: number; riderPublicId: string; collectionId: string }>;
  failures: Array<{ rowNumber: number; riderPublicId: string; message: string }>;
}

const bulkCreate = async (file: File): Promise<BulkManualCollectionResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post(`${BASE}/bulk`, formData, {
    headers: authHeaders(),
  });
  return res.data;
};

const update = async (id: string, payload: any) => {
  const res = await axios.put(`${BASE}/${encodeURIComponent(id)}`, payload, { headers: authHeaders() });
  return res.data;
};

const getPendingRiders = async () => {
  const res = await axios.get(`${BASE}/pending/riders`, { headers: authHeaders() });
  return res.data;
};

const exportPendingRiders = async () => {
  const res = await axios.get(`${BASE}/pending/riders/export`, {
    headers: authHeaders(),
    responseType: 'arraybuffer',
  });
  return res;
};

const getTotalPendingAmount = async () => {
  const res = await axios.get(`${BASE}/pending-amount`, { headers: authHeaders() });
  return res.data;
};

const getMonthlyAnalytics = async (params?: any) => {
  const res = await axios.get(`${BASE}/analytics/monthly`, { params, headers: authHeaders() });
  return res.data;
};

const getCityAnalytics = async (params?: any) => {
  const res = await axios.get(`${BASE}/analytics/city`, { params, headers: authHeaders() });
  return res.data;
};

export default {
  list,
  exportAll,
  listByCity,
  create,
  bulkCreate,
  update,
  getPendingRiders,
  exportPendingRiders,
  getTotalPendingAmount,
  getMonthlyAnalytics,
  getCityAnalytics,
};
